import React from 'react';
import PropTypes from 'prop-types';

const InstallRedirect = ({ $location }) => {
  React.useEffect(() => {
    const {
      'classic-beta': classicBeta,
      'classic-training': classicTraining,
      'classic-dev': classicDev,
      classic,
      beta,
      dev,
      training,
      fly,
    } = $location.search();

    let appType = 'classic';
    if (classicBeta || classicTraining || classicDev || classic) {
      appType = 'classic';
    } else if (beta) {
      appType = 'fly-beta';
    } else if (training) {
      appType = 'fly-demo';
    } else if (dev || fly) {
      appType = 'fly';
    }

    window.location.replace(`https://os.resy.com/install/${appType}`);
  }, [$location]);

  return null;
};

InstallRedirect.propTypes = {
  $location: PropTypes.shape({
    search: PropTypes.func.isRequired,
  }).isRequired,
};

export default InstallRedirect;
